import * as React from "react";
import { api } from "@repo/convex/convex/_generated/api";
import { useState } from "react";
import { Button } from "@radix-ui/themes";
import { PlusIcon } from "@radix-ui/react-icons";
import { useQuery } from "convex-helpers/react/cache/hooks";
import { AddItemDialog } from "../common/AddItemDialog.tsx";
import { PageHeader } from "../common/PageHeader.tsx";
import { ItemsScrollArea } from "../common/items/ItemsScrollArea.tsx";
import { StashItem } from "./StashItem.tsx";
import { usePaginatedItems } from "../common/hooks.ts";
import { UnreadItemDoc } from "@repo/convex/convex/schema.ts";
import { ListedItem } from "@repo/convex/convex/items.ts";

interface Props {}

export const StashPage: React.FC<Props> = ({}) => {
  const { status, loadMore, isLoading, items } = usePaginatedItems({
    statusKind: "unread",
  });
  const count = useQuery(api.items.count, { statusKind: "unread" });
  const [isAddOpen, setIsAddOpen] = useState(false);

  return (
    <>
      {isAddOpen && <AddItemDialog setIsOpen={setIsAddOpen} />}
      <PageHeader
        title="The Stash"
        logo
        subtitle={waiting(count)}
        actions={
          <>
            <Button className="only-desktop" size="3" onClick={() => setIsAddOpen(true)}>
              <PlusIcon /> Stash a link
            </Button>
            <button
              type="button"
              className="paper-button round only-phone"
              aria-label="Stash a link"
              onClick={() => setIsAddOpen(true)}
            >
              <PlusIcon />
            </button>
          </>
        }
      />
      <ItemsScrollArea
        items={items}
        isLoading={isLoading}
        onAddItem={() => setIsAddOpen(true)}
        empty={{
          title: "Nothing waiting",
          detail: "Stash a link here, from the StashIt extension in Chrome, or from your phone.",
        }}
        renderItem={(item) => <StashItem key={item._id} item={item as ListedItem<UnreadItemDoc>} />}
        onLoadMore={() => loadMore(20)}
        canLoadMore={status == "CanLoadMore"}
      />
    </>
  );
};

const waiting = (count: number | undefined) => {
  if (count === undefined) return "\u00a0";
  if (count == 0) return "all read, somehow";
  if (count == 1) return "1 waiting for you";
  return `${count >= 500 ? "500+" : count} waiting for you`;
};
